<!--
 * @Author: your name
 * @Date: 2020-09-25 10:50:24
 * @LastEditTime: 2020-10-13 18:50:09
 * @LastEditors: jml
 * @Description: In User Settings Edit
 * @FilePath: \saas-polymerization-c\src\views\game\puzzle\index.vue
-->
<template>
  <div class="puzzle">
    <div class="stance-1">
      <lLogo :logo="info.isOpenLogo==1?info.companyLogoUrl:''" class="logo-box"></lLogo>
      <img src="../img/puzzle/bg2.png" alt class="bg absolute" />
      <img src="../img/puzzle/title.png" alt class="title absolute" />
      <img src="../img/puzzle/i.png" class="i absolute" />
      <div class="nav absolute">
        <div
          class="item"
          v-for="(item,index) in nav"
          :key="index"
          :class="{active:nowIndex==index}"
          @click="changeNav(index)"
        >
          <img class="img" :src="item.img" alt />
          <img class="imgb" :src="item.imgb" alt />
        </div>
      </div>
      <div class="content absolute content-0" v-show="nowIndex == 0">
        <img class="bg" :src="nav[0].bg" alt />
        <div class="o-bg">
          <img class="bg2" src="../img/puzzle/all-bg.png" alt />
        </div>
        <div class="c" style="height: calc(100vh - 4.2rem - 2.8rem)">
          <div
            class="c-item"
            v-for="(cItem,cIndex) in (rule.concat(addressInfo)).filter(i=>i)"
            :key="cIndex"
          >
            <div class="title">
              <img :src="cItem.icon" class="icon" alt />
              <span>{{cItem.name}}</span>
            </div>
            <div class="text" v-html="cItem.content"></div>
            <div class="address-edit" v-if="cItem.isAddress" @click="showAddressDialog">
              <van-icon name="edit" class="icon" />
              <span>修改</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content absolute content-1" v-show="nowIndex == 1">
        <img class="bg" :src="nav[1].bg" alt />
        <div class="o-bg">
          <img class="bg2" src="../img/puzzle/all-bg-2.png" alt />
        </div>
        <div class="c">
          <div class="rank-tips">只显示前50名</div>
          <div class="diyi f" :class="{mine:myUserId==(rank[0]||{}).userId}">
            <img class="icon" src="../img/puzzle/r-1.png" alt />
            <div class="name">{{(rank[0]||{}).fullName | filterNormalValue}}</div>
            <div
              class="time"
              v-if="(rank[0]||{}).bestAchievement"
            >{{(rank[0]||{}).bestAchievement | filetrBestAchievement}}秒</div>
            <div v-else class="time">暂无</div>
          </div>
          <div class="dier f" :class="{mine:myUserId==(rank[1]||{}).userId}">
            <img class="icon" src="../img/puzzle/r-2.png" alt />
            <div class="name">{{(rank[1]||{}).fullName | filterNormalValue}}</div>
            <div
              class="time"
              v-if="(rank[1]||{}).bestAchievement"
            >{{(rank[1]||{}).bestAchievement | filetrBestAchievement}}秒</div>
            <div v-else class="time">暂无</div>
          </div>
          <div class="disan f" :class="{mine:myUserId==(rank[2]||{}).userId}">
            <img class="icon" src="../img/puzzle/r-3.png" alt />
            <div class="name">{{(rank[2]||{}).fullName | filterNormalValue}}</div>
            <div
              class="time"
              v-if="(rank[2]||{}).bestAchievement"
            >{{(rank[2]||{}).bestAchievement | filetrBestAchievement}}秒</div>
            <div v-else class="time">暂无</div>
          </div>
          <div class="group">
            <div
              class="c-item"
              v-for="(cItem,cIndex) in rank.slice(3)"
              :key="cIndex"
              :class="{mine:myUserId==cItem.userId}"
            >
              <div class="index">{{`${cIndex+4}`.padStart(2,0)}}</div>
              <div class="c-index">第{{cIndex+4}}名</div>
              <div class="name">{{cItem.fullName | filterNormalValue}}</div>
              <div class="time">{{cItem.bestAchievement | filetrBestAchievement}}秒</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content absolute content-2" v-show="nowIndex == 2">
        <img class="bg" :src="nav[2].bg" alt />
        <div class="o-bg">
          <img class="bg2" src="../img/puzzle/all-bg.png" alt />
        </div>
        <div class="c">
          <div class="c-item" v-for="(cItem,cIndex) in rewards" :key="cIndex">
            <div class="img">
              <img
                :src="cItem.prizeType==1?cItem.prizeUrl:'https://cdn.yxvzb.com/WEB/SaaS/images/ptJifen.png'"
                :class="{goods:cItem.prizeType==1,jifen:cItem.prizeType==2}"
                class="icon"
                alt
              />
              <div class="index">{{cItem.prizeGrade}}</div>
            </div>
            <div class="name">{{cItem.prizeType==2?`${cItem.integral}积分`:cItem.prizeName}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateFormat from '@/utils/dateFormat';
import lLogo from './components/logo';
import lAddress from '../components/address';
import { customerUser } from '@/api/ajax';
import { puzzle } from '@/api/game';
import { mapMutations, mapActions, mapState } from 'vuex';
import { getStorage } from '@/utils/storage';
import { game } from '../mixins/game';
export default {
  name: 'puzzleGameRule',
  mixins: [game],
  components: { lLogo },
  data() {
    return {
      nowIndex: 1,
      myUserId: 0,
      nav: [
        {
          img: require('../img/puzzle/t-1.png'),
          imgb: require('../img/puzzle/t-1-a.png'),
          bg: require('../img/puzzle/t-1-bg.png')
        },
        {
          img: require('../img/puzzle/t-2.png'),
          imgb: require('../img/puzzle/t-2-a.png'),
          bg: require('../img/puzzle/t-2-bg.png')
        },
        {
          img: require('../img/puzzle/t-3.png'),
          imgb: require('../img/puzzle/t-3-a.png'),
          bg: require('../img/puzzle/t-3-bg.png')
        }
      ],
      addressInfo: null,
      rank: []
    };
  },
  computed: {
    ...mapState({
      rewards: state => state.game.rewards,
      info: state => state.game.info
    }),
    rule() {
      const { channelNo } = this.$route.params;
      const {
        startDt,
        endDt,
        organizerCompany,
        activityExplain,
        customerServicePhone
      } = this.info;
      return [
        {
          icon: require('../img/puzzle/icon1.png'),
          name: '活动时间',
          content: `${dateFormat(
            startDt,
            'YYYY年MM月DD日 HH:mm'
          )}--${dateFormat(endDt, 'YYYY年MM月DD日 HH:mm')}`
        },
        organizerCompany
          ? {
              icon: require('../img/puzzle/icon2.png'),
              name: '主办单位',
              content: organizerCompany
            }
          : null,
        activityExplain
          ? {
              icon: require('../img/puzzle/icon3.png'),
              name: '活动说明',
              content: activityExplain
            }
          : null,
        customerServicePhone
          ? {
              icon: require('../img/puzzle/icon4.png'),
              name: '客服电话',
              content: `联系电话：${customerServicePhone}`
            }
          : null
      ];
    }
  },
  filters: {
    filetrBestAchievement(time) {
      return (time / 1000).toFixed(2);
    },
    filterNormalValue(value) {
      return value || '-';
    }
  },
  methods: {
    showAddressDialog() {
      if (this.isEdit && !this.isPreview) {
        return;
      }
      this.$xrkDialog({
        content: lAddress,
        hideConfirm: true,
        confirmText: '完成',
        callback: params => {
          this.$toast.success('填写成功');
          const index = this.rule.findIndex(item => item && item.isAddress);
          const {
            consignee,
            consigneePeople,
            address,
            provinceName,
            cityName,
            districtName
          } = params;
          const obj = {
            isAddress: true,
            icon: require('../img/puzzle/icon5.png'),
            name: '联系方式',
            content: `姓名：${consignee || '未填写'}<br>联系电话：${
              consigneePeople || '未填写'
            }<br>联系地址：${
              address
                ? provinceName + cityName + districtName + address
                : '未填写'
            }`
          };
          if (index == -1) {
            this.rule.push(obj);
          } else {
            this.$set(this.rule, index, obj);
          }
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      });
    },
    changeNav(index) {
      this.nowIndex = index;
    },
    async getRankList() {
      const { id, channelNo } = this.$route.params;
      const {
        data: { data }
      } = await puzzle.rankList({
        channelNo,
        activityId: id
      });
      this.rank = data.slice(0, 50);
      const storageObj = getStorage('channel' + channelNo) || {};
      this.myUserId = storageObj.id || this.myUserId;
    },
    async getAddressInfo() {
      let address,
        provinceName,
        cityName,
        districtName,
        consigneePeople,
        consignee;
      // 判断是否登录
      let {
        data: { data }
      } = await customerUser.obtainLoginUser();
      const isLogin = !!data;
      if (isLogin) {
        const addressRes = await puzzle.addressData();
        const obj = addressRes.data.data || {};
        address = obj.address;
        provinceName = obj.provinceName;
        cityName = obj.cityName;
        districtName = obj.districtName;
        consigneePeople = obj.consigneePeople;
        consignee = obj.consignee;
        this.myUserId = data.id;
      }
      return isLogin || this.isEdit
        ? {
            isAddress: true,
            icon: require('../img/puzzle/icon5.png'),
            name: '联系方式',
            content: `姓名：${consignee || '未填写'}<br>联系电话：${
              consigneePeople || '未填写'
            }<br>联系地址：${
              address
                ? provinceName + cityName + districtName + address
                : '未填写'
            }`
          }
        : null;
    }
  },
  async created() {
    const info = await this.getAddressInfo();
    this.addressInfo = info;
    if (this.isEdit) {
      const arr = [];
      arr.length = 8;
      arr.fill({
        activityId: 1,
        bestAchievement: 6473,
        fullName: '示例',
        rank: 1.0,
        id: 3,
        userId: 58,
        headPhoto: null
      });
      this.rank = arr;
    } else {
      if (!this.isPreview) {
        this.setShareUrl();
        this.getRankList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.puzzle {
  width: 10rem;
  overflow: hidden;
  .absolute {
    position: absolute;
  }
  .stance-1 {
    width: 100%;
    min-height: 100vh;
    position: relative;
    & > .logo-box {
      position: absolute;
      bottom: -0.3rem;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
    }
    & > .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    & > .title {
      width: 8.213rem;
      height: 1.787rem;
      top: 0.68rem;
      left: 0.933rem;
    }
    & > .nav {
      width: 9.3rem;
      left: 0.347rem;
      top: 2.3rem;
      height: 1.4rem;
      display: flex;
      z-index: 2;
      .item {
        width: 3.2rem;
        height: 1.6rem;
        text-align: center;
        padding-top: 0.45rem;
        .imgb {
          display: none;
          height: 0.4rem;
        }
        .img {
          display: inline-block;
          height: 0.4rem;
        }
        &.active {
          .imgb {
            display: inline-block;
          }
          .img {
            display: none;
          }
        }
      }
    }
    & > .content {
      z-index: 1;
      width: 9.3rem;
      height: calc(100vh - 4.2rem);
      left: 0.347rem;
      top: 2.3rem;
      overflow: hidden;
      border-radius: 0.4rem;
      & > .bg {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
      }
      & > .o-bg {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: calc(100vh - 5.8rem);
        overflow: hidden;
        & > .bg2 {
          position: absolute;
          left: 0;
          bottom: 0;
          z-index: 2;
        }
      }
      & > .c {
        height: calc(100vh - 4.2rem - 1.8rem);
        overflow: auto;
      }
      &-0 {
        & > .c {
          width: 100%;
          position: absolute;
          top: 1.64rem;
          z-index: 3;
          // height: 13.507rem - 2rem;
          .c-item {
            width: 8.893rem;
            border-radius: 0.373rem;
            border: solid 1px #ff5267;
            margin: 0 auto;
            margin-bottom: 0.5rem;
            padding-top: 0.25rem;
            padding-left: 0.57rem;
            padding-right: 0.37rem;
            padding-bottom: 0.29rem;
            box-sizing: border-box;
            .title {
              display: flex;
              align-items: center;
              font-size: 0.373rem;
              color: #54000a;
              letter-spacing: 0.037rem;
              font-weight: bold;
              margin-bottom: 0.1rem;
              .icon {
                height: 0.45rem;
                margin-right: 0.2rem;
              }
            }
            .text {
              font-size: 0.32rem;
              line-height: 0.4rem;
              color: #e91f2c;
            }
            &:last-child {
              // margin-bottom: 1rem;
              padding-right: 1.2rem;
              // border-right: none;
            }
            position: relative;
            .address-edit {
              position: absolute;
              right: -3px;
              top: -1px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              width: 1rem;
              background-color: #ff5267;
              height: calc(100% + 2px);
              border-top-right-radius: 0.373rem;
              border-bottom-right-radius: 0.373rem;
              color: #ffe4e7;
              font-size: 0.373rem;
              z-index: 4;
              .icon {
                font-size: 0.6rem;
              }
            }
          }
        }
      }
      &-1 {
        & > .c {
          width: 100%;
          position: absolute;
          left: 0;
          top: 1.64rem;
          z-index: 3;
          // height: 13.507rem - 2rem;
          .rank-tips {
            width: 100%;
            position: absolute;
            top: 0;
            font-size: 0.32rem;
            line-height: 1;
            color: #c19a9e;
            display: flex;
            align-items: center;
            justify-content: center;
            &::after,
            &::before {
              content: '';
              display: block;
              width: 0.4rem;
              height: 1px;
              background-color: #d2a6ab;
              margin: 0 0.3rem;
            }
          }
          .f {
            width: 30%;
            position: absolute;
            text-align: center;
            transform: translateY(0.5rem);
            &.mine {
              position: absolute;
              &::after {
                position: absolute;
                content: '我';
                border-bottom-left-radius: 0.627rem;
                border-bottom-right-radius: 0.627rem;
                background-image: linear-gradient(
                    183deg,
                    #fa973e 0%,
                    #ff0808 100%
                  ),
                  linear-gradient(#fc922c, #fc922c);
                right: -0.4rem;
                top: 0rem;
                font-size: 0.373rem;
                color: #ffe4e7;
                box-sizing: border-box;
                padding: 0 0.1rem;
                padding-top: 0.05rem;
              }
            }
            .icon {
              margin-bottom: 0.2rem;
            }
            .name {
              font-size: 0.373rem;
              line-height: 1;
              font-weight: 500;
              color: #54000a;
              width: 3rem;
              text-align: center;
              transform: translateX(-0.56rem);
            }
            .time {
              margin-top: 0.15rem;
              font-size: 0.32rem;
              line-height: 1;
              color: #e91f2c;
            }
            &.diyi {
              width: 3.093rem;
              left: 50%;
              transform: translateY(0.5rem) translateX(-50%);
              &::after {
                right: 0;
              }
              .icon {
                width: 3.093rem;
                height: 2.747rem;
              }
              .name,
              .time {
                transform: translateX(0.093rem / 2) translateY(-0.62rem);
              }
            }
            &.dier {
              width: 1.88rem;
              left: 0.747rem;
              top: 0.55rem;
              .icon {
                width: 1.88rem;
                height: 1.6rem;
              }
            }
            &.disan {
              width: 1.88rem;
              right: 0.747rem;
              top: 0.55rem;
              .icon {
                width: 1.88rem;
                height: 1.6rem;
              }
            }
          }
          .group {
            width: 100%;
            height: calc(100% - 4.1rem);
            overflow: auto;
            margin-top: 4.1rem;
          }
          .c-item {
            padding-top: 0.29rem;
            padding-left: 0.68rem;
            padding-right: 0.92rem;
            padding-bottom: 0.29rem;
            display: flex;
            align-items: center;
            &.mine {
              width: 8.8rem;
              margin-left: 0.25rem;
              background-color: #ffe4e7;
              border: solid 0.013rem #d98f97;
              box-sizing: border-box;
              padding-left: 0.43rem;
              padding-right: 0.92rem - 0.25rem;
              position: relative;
              overflow: hidden;
              &::after {
                position: absolute;
                content: '我';
                width: 1.027rem;
                height: 0.627rem;
                border-radius: 0.627rem;
                background-image: linear-gradient(
                    183deg,
                    #fa973e 0%,
                    #ff0808 100%
                  ),
                  linear-gradient(#fc922c, #fc922c);
                right: -0.3rem;
                top: -0.1rem;
                font-size: 0.373rem;
                color: #ffe4e7;
                box-sizing: border-box;
                padding-left: 0.2rem;
                padding-top: 0.05rem;
              }
            }
            .index {
              width: 0.68rem;
              height: 0.68rem;
              background-image: linear-gradient(
                  183deg,
                  #e94d17 0%,
                  #54000a 100%
                ),
                linear-gradient(#9c3541, #9c3541);
              font-size: 0.373rem;
              line-height: 1;
              color: #ffc5cb;
              border-radius: 0.68rem;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 0.29rem;
            }
            .c-index {
              font-size: 0.373rem;
              line-height: 1;
              color: #54000a;
              width: 1.4rem;
            }
            .name {
              font-size: 0.373rem;
              line-height: 1;
              color: #e91f2c;
              flex-grow: 1;
              text-align: center;
              padding-right: 0.6rem;
            }
            .time {
              font-size: 0.373rem;
              line-height: 1;
              color: #e91f2c;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      &-2 {
        & > .c {
          width: 100%;
          padding-top: 0.67rem;
          padding-left: 0.5rem;
          padding-right: 0.5rem;
          position: absolute;
          left: 0;
          top: 1.25rem;
          z-index: 3;
          // display: flex;
          // justify-content: space-between;
          // flex-wrap: wrap;
          // height: 13.507rem - 2rem;
          .c-item {
            display: inline-block;
            vertical-align: bottom;
            width: 2.28rem;
            height: 3.5rem;
            margin-right: 0.72rem;
            &:nth-child(3n + 3) {
              margin-right: 0;
            }
            .img {
              width: 2.28rem;
              height: 1.893rem;
              background-color: #ffffff;
              border-radius: 0.32rem;
              border: solid 0.013rem #fe8c99;
              display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              overflow: hidden;
              .icon {
                width: 100%;
                height: 100%;
                &.goods {
                  width: 2.28rem - 0.6rem;
                  height: 1.893rem - 0.6rem;
                }
                &.jifen {
                  width: 1.64rem;
                  height: 0.88rem;
                }
              }
              .index {
                position: absolute;
                height: 0.627rem;
                background-image: linear-gradient(
                    183deg,
                    #fa973e 0%,
                    #ff0808 100%
                  ),
                  linear-gradient(#fc922c, #fc922c);
                background-blend-mode: normal, normal;
                border-radius: 0.627rem;
                font-size: 0.32rem;
                line-height: 1;
                color: #ffffff;
                padding-top: 0.24rem;
                padding-left: 0.2rem;
                box-sizing: border-box;
                top: -0.2rem;
                right: -0.3rem;
                padding-right: 0.5rem;
                &:empty {
                  display: none;
                }
              }
            }
            .name {
              width: 2.347rem;
              height: 0.707rem;
              font-size: 0.32rem;
              line-height: 0.4rem;
              color: #e91f2c;
              text-align: center;
              margin-top: 0.2rem;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    & > .i {
      right: 0;
      width: 2.227rem;
      height: 2.067rem;
      bottom: -0.5rem;
    }
  }
}
</style>
